/* VINEY (Húðin þín, S5a; Build Spec 3.1, boards D1-phone-play, D1-phone-states, D1-desktop-play): the collection
   header's behaviour (snippets/vn-skin-header.liquid, styles in vn-skin.css).
   1. A press on a concern tile or chip, or a skin-type chip, picks it (at most one of each); a press on the picked
      one drops it. The page answers at once (the pressed state, the stem, the leaf, the berry) and then Shopify's
      own filters show the address: Horizon's filter form fetches and swaps the section (assets/facets.js,
      vnShowURL), so its wait, give-up and retry apply. A skin type sends its own value and "Allar húðgerðir".
   2. "Hreinsa val" (list) and "Hreinsa" (sheet) take both picks out of the address and forget them.
   3. The pick is kept in the shopper's own browser (localStorage "vn-skin", {c, t} word-list keys) and comes
      back on a header collection opened with no filter in its address; a link with a pick in it is kept too.
   4. The sheet (phone and tablet): open, close, Esc, the dim, the drag and Back are Horizon's dialog with
      vn-motion.js section 11 (key "skin"). Picks made in it replace the address instead of adding steps, so
      Back closes the sheet; once it has closed the address carries the picks as one step.
      The opener keeps aria-expanded through a section refresh, and focus returns to it. A pick that fails in the
      sheet (the give-up puts the address back) is not brought back when it closes. Opened while a request runs, the
      sheet shows its wait, give-up and retry too.
   5. Back and Forward: the results, the filter controls and the header follow the address (facets.js vnSyncToURL).
   6. The product page (S5b): see section 6 below. */
(() => {
  if (/** @type {any} */ (window).vnSkin) return;
  /** @type {any} */ (window).vnSkin = true;
  const KEY = 'vn-skin';
  const P = ['c', 't'];
  const root = () => document.getElementById('vn-hud');
  const sheet = () => /** @type {HTMLDialogElement | null} */ (document.getElementById('vn-skin-sheet'));
  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } },
    // true when the pick was written (round 2: the product page then knows whether storage or its own copy is current)
    set(/** @type {any} */ v) { try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); return true; } catch { return false; /* no storage: the pick is not kept */ } },
  };
  const save = (/** @type {any} */ pick) => store.set(pick.c || pick.t ? { ...(pick.c ? { c: pick.c } : {}), ...(pick.t ? { t: pick.t } : {}) } : null);
  const names = () => { const r = root(); return { c: r?.dataset.pc || '', t: r?.dataset.pt || '' }; };
  const btn = (/** @type {string} */ p, /** @type {string} */ k) => /** @type {HTMLElement | null} */ (root()?.querySelector(`[data-p="${p}"][data-k="${k}"][data-v]`));
  // the pick an address carries: the button whose first value it holds
  const picked = (/** @type {string} */ href) => {
    const r = root();
    const sp = new URL(href).searchParams;
    const n = names();
    /** @type {any} */ const out = {};
    if (!r) return out;
    P.forEach((p) => {
      const have = sp.getAll(n[p]);
      if (!have.length) return;
      const b = [...r.querySelectorAll(`[data-p="${p}"][data-v]`)].find((x) => have.includes(/** @type {HTMLElement} */ (x).dataset.v?.split(' ')[0] || ''));
      if (b) out[p] = /** @type {HTMLElement} */ (b).dataset.k;
    });
    return out;
  };
  const urlFor = (/** @type {any} */ pick) => {
    const u = new URL(window.location.href);
    const n = names();
    P.forEach((p) => {
      if (!n[p]) return;
      u.searchParams.delete(n[p]);
      const b = pick[p] && btn(p, pick[p]);
      if (b) (b.dataset.v || '').split(' ').filter(Boolean).forEach((v) => u.searchParams.append(n[p], v));
    });
    u.searchParams.delete('page');
    return u.toString();
  };
  // the answer at once: pressed states, the stems and leaves, the berry, the pill's outline
  const paint = (/** @type {any} */ pick, /** @type {Element | null} */ r = root()) => {
    if (!r) return;
    r.querySelectorAll('[data-p]').forEach((el) => {
      const b = /** @type {HTMLElement} */ (el);
      const on = pick[b.dataset.p || ''] === b.dataset.k;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', String(on));
    });
    const grp = (/** @type {string} */ sel, /** @type {string} */ p) => {
      const b = pick[p] ? r.querySelector(`[data-p="${p}"][data-k="${pick[p]}"]`) : null;
      const c = b ? [...b.classList].find((x) => /^vn-c\d$/.test(x)) : null;
      r.querySelectorAll(sel).forEach((g) => {
        g.classList.remove('vn-c1', 'vn-c2', 'vn-c3', 'vn-c4', 'vn-c5');
        g.classList.toggle('on', !!c);
        if (c) g.classList.add(c);
      });
    };
    grp('.vn-hud__g1', 'c');
    grp('.vn-hud__g2', 't');
    const any = !!(pick.c || pick.t);
    r.querySelectorAll('.vn-hud__ft, .vn-hud__vrow').forEach((el) => el.classList.toggle('on', any));
    r.querySelector('.vn-hud__pill')?.classList.toggle('set', any);
  };
  const now = () => {
    /** @type {any} */ const o = {};
    P.forEach((p) => { const b = /** @type {HTMLElement | null} */ (root()?.querySelector(`[data-p="${p}"][aria-pressed="true"]`)); if (b) o[p] = b.dataset.k; });
    return o;
  };
  const form = () => /** @type {any} */ (root()?.closest('.shopify-section')?.querySelector('facets-form-component'));
  const show = (/** @type {string} */ url, /** @type {boolean} */ replace) => {
    const f = form();
    if (f && typeof f.vnShowURL === 'function') f.vnShowURL(url, { replace, noVT: replace });
    else window.location.assign(url);
  };

  // picks made in the open sheet: the address to leave behind once it has closed (see 4)
  /** @type {string | null} */ let sess = null;

  document.addEventListener('click', (e) => {
    const t = /** @type {HTMLElement | null} */ (/** @type {Element} */ (e.target).closest?.('#vn-hud [data-p], #vn-hud [data-vn-sk-clear]'));
    if (!t) return;
    /** @type {any} */ let pick;
    if (t.hasAttribute('data-vn-sk-clear')) pick = {};
    else {
      // a tile with nothing behind it stays where it is (aria-disabled, still focusable)
      if (t.getAttribute('aria-disabled') === 'true' || !t.dataset.v) return;
      const p = t.dataset.p || '';
      pick = now();
      if (pick[p] === t.dataset.k) delete pick[p];
      else pick[p] = t.dataset.k;
    }
    paint(pick);
    save(pick);
    const url = urlFor(pick);
    const open = !!sheet()?.open;
    if (open) sess = url;
    // the pressed state, stem and leaf get their frame first; the section request starts right after it
    requestAnimationFrame(() => setTimeout(() => show(url, open), 0));
  });

  // Back and Forward, and the sheet's close (vn-motion.js pops its history step). After the sheet, the address the
  // page shows goes back in as one step. Then the results follow the address: Horizon does not re-render on Back,
  // so the filter form fetches the results for it without a new step (nothing happens when they are on the screen)
  window.addEventListener('popstate', () => {
    if (!root() || history.state?.vnOverlay) return;
    if (sess) {
      const want = sess;
      sess = null;
      if (window.location.href !== want) history.pushState('', '', want);
    }
    form()?.vnSyncToURL?.();
  });

  // a give-up puts the address back to the results on the screen, "Reyna aftur" forward again; the header follows
  // the address, and the open sheet's session ends on that address too
  document.addEventListener('filter:update', () => {
    if (!root()) return;
    if (sess !== null) sess = window.location.href;
    paint(picked(window.location.href));
  });

  const init = () => {
    const r = root();
    const d = sheet();
    if (!r || r.dataset.vnInit) return;
    r.dataset.vnInit = '1';
    const pill = /** @type {HTMLElement | null} */ (r.querySelector('.vn-hud__pill'));
    if (d) {
      d.addEventListener('close', () => {
        setTimeout(() => { sess = null; }, 300);
        const p = /** @type {HTMLElement | null} */ (document.querySelector('#vn-hud .vn-hud__pill'));
        if (p && document.activeElement !== p) p.focus({ preventScroll: true });
      });
      // a section refresh puts the server's aria-expanded back; the open sheet keeps its opener marked
      new MutationObserver(() => {
        const p = r.querySelector('.vn-hud__pill');
        const want = String(!!d.open && !d.classList.contains('dialog-closing'));
        if (p && p.getAttribute('aria-expanded') !== want) p.setAttribute('aria-expanded', want);
      }).observe(r, { attributes: true, subtree: true, attributeFilter: ['aria-expanded'] });
      // round 2: the sheet opened while a request runs (or its give-up shows) takes in that wait (facets.js vnJoin)
      new MutationObserver((recs) => { if (recs.some((m) => m.target === sheet() && sheet()?.open)) form()?.vnJoin?.('sheet'); }).observe(r, { attributes: true, subtree: true, attributeFilter: ['open'] });
    }
    pill?.setAttribute('aria-expanded', 'false');
    const cur = now();
    const sp = new URL(window.location.href).searchParams;
    if (cur.c || cur.t) return save(cur);
    if ([...sp.keys()].some((k) => k.startsWith('filter.'))) return;
    const s = store.get();
    if (!s || typeof s !== 'object') return;
    /** @type {any} */ const pick = {};
    P.forEach((p) => { if (typeof s[p] === 'string' && btn(p, s[p])) pick[p] = s[p]; });
    if (!pick.c && !pick.t) return;
    paint(pick);
    customElements.whenDefined('facets-form-component').then(() => show(urlFor(pick), true));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  // 6. The product page (S5b; Build Spec 3.2, blocks/vn-skinfit.liquid). The "Hentar þér?" panel paints the stored
  //    pick itself (window.vnFitPaint, printed with the panel, so it shows before this file runs). With nothing stored,
  //    its "Húðin þín" pill opens the collection's own choice: the sheet's groups, counts and buttons come from the
  //    collection (sections/vn-skin-pick.liquid), fetched once the pill nears the screen or takes focus. Up to 989px it
  //    is the bottom sheet and "Sýna {N} vörur" goes to the collection with the picks; from 990px the same dialog is a
  //    440 px drawer at the right and "Vista" closes it. Open, close, Esc, the dim, the drag and Back are Horizon's
  //    dialog with vn-motion.js section 11 (key "skin"). Every press is kept at once and the panel behind follows;
  //    the counts follow the pick, and counts that wait longer than 300 ms dim until they land (rule 8). If the first
  //    fetch fails, the pill takes the shopper to the collection, where the same choice is.
  //    The shell is put in before DOMContentLoaded, so vn-motion.js watches it like the collection's sheet.
  //    After verifier round 1: the counts' wait is the collection sheet's (vnLoader 'sheet': the stem from 300 ms, the
  //    line at 2.5 s, the give-up at 10 s); a give-up with the sheet open puts back the pick whose counts are on the
  //    screen and "Reyna aftur" asks again (as the collection's sheet); a give-up after it closed keeps the pick and the
  //    counts are asked again on the next open. The pick is also held here, so a browser that keeps no storage still
  //    marks the panel. A refresh (a shade or size change morphs the section) keeps the open sheet's opener marked, and a
  //    page brought back from the back-forward cache shows the pick kept since.
  //    After verifier round 2: a count request still out when the page comes back from the back-forward cache is
  //    dropped (its answer would paint a pick the page no longer keeps), and its wait ends; once a write fails (storage
  //    full or write-blocked while reads work), the pick held here is the current one until a write succeeds again.
  const fitEl = () => /** @type {HTMLElement | null} */ (document.querySelector('.vn-fit[data-m]'));
  const pdp = () => {
    const el0 = fitEl();
    if (!el0 || root() || document.getElementById('vn-skin-dc')) return;
    const coll = el0.dataset.u || '';
    const desk = window.matchMedia('(min-width: 990px)');
    // the stored pick (null: this browser keeps no storage, or the last write failed) and the one held here
    /** @type {any} */ let mem = {};
    let unsaved = false;
    const stored = () => { if (unsaved) return null; try { const s = JSON.parse(localStorage.getItem(KEY) || 'null'); return s && typeof s === 'object' ? s : {}; } catch { return null; } };
    const cur = () => stored() || mem;
    const keep = (/** @type {any} */ pick) => { mem = { ...(pick.c ? { c: pick.c } : {}), ...(pick.t ? { t: pick.t } : {}) }; unsaved = !save(pick); };
    const fitPaint = () => /** @type {any} */ (window).vnFitPaint?.(fitEl(), stored() ? undefined : mem);
    const host = document.createElement('div');
    host.className = 'vn-hud vn-fit__hud';
    // vnLoader (vn-motion.js section 7) finds its wait inside an element with a section's id
    host.id = 'shopify-section-vn-fit-pick';
    host.innerHTML = '<dialog-component id="vn-skin-dc"><dialog ref="dialog" id="vn-skin-sheet" class="vn-hud__sheet vn-fit__dr" aria-labelledby="vn-hud-h" scroll-lock></dialog></dialog-component>';
    document.body.append(host);
    const dc = /** @type {any} */ (host.firstElementChild);
    const d = /** @type {HTMLDialogElement} */ (dc.firstElementChild);
    const isOpen = () => d.open && !d.classList.contains('dialog-closing');
    // vn-motion.js (a deferred script, so it started before this module) watches the sheet from here on
    /** @type {any} */ (window).vnWatchOverlay?.(d);
    /** @type {any} */ let names = { c: '', t: '' };
    // imported nodes; the chips' counts carry a class, so the wait's dim is styled by a class (Playbook section 4)
    const own = (/** @type {Node} */ n) => { const x = /** @type {any} */ (document.importNode(n, true)); x.querySelectorAll?.('.vn-hud__chip small').forEach((/** @type {Element} */ s) => s.classList.add('vn-fit__cn')); return x; };
    // the address of the collection with a pick in it (the values the sheet's own buttons carry)
    const urlOf = (/** @type {any} */ pick, /** @type {boolean} */ part) => {
      const u = new URL(coll, window.location.origin);
      if (part) u.searchParams.set('section_id', 'vn-skin-pick');
      P.forEach((p) => {
        const b = pick[p] && /** @type {HTMLElement | null} */ (d.querySelector(`[data-p="${p}"][data-k="${pick[p]}"][data-v]`));
        if (b && names[p]) (b.dataset.v || '').split(' ').filter(Boolean).forEach((v) => u.searchParams.append(names[p], v));
      });
      return u.toString();
    };
    // the give-up, as the collection's (section-renderer.js SECTION_DEADLINE_MS)
    const DEADLINE = 10000;
    /** @type {AbortController | null} */ let ctl = null;
    const get = (/** @type {string} */ url) => {
      ctl?.abort();
      const c = (ctl = new AbortController());
      const to = setTimeout(() => c.abort(), DEADLINE);
      return fetch(url, { signal: c.signal, credentials: 'same-origin' }).then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.text(); }).then((t) => {
        const doc = new DOMParser().parseFromString(t, 'text/html');
        const hud = doc.getElementById('vn-hud');
        const sh = doc.getElementById('vn-skin-sheet');
        if (!hud || !sh) throw new Error('no choice');
        return { hud, sh, str: doc.getElementById('vn-strings') };
      }).finally(() => clearTimeout(to));
    };
    const fill = (/** @type {any} */ { hud, sh, str }) => {
      names = { c: hud.dataset.pc || '', t: hud.dataset.pt || '' };
      const defs = hud.querySelector('.vn-hud__defs');
      if (defs && !document.getElementById('vn-hudl')) host.prepend(own(defs));
      // the wait's words, when the page has no product grid that printed them
      if (str && !document.getElementById('vn-strings')) host.append(own(str));
      const buy = sh.querySelector('.vn-hud__buy');
      if (buy) {
        buy.removeAttribute('on:click');
        buy.setAttribute('data-vn-fit-go', '');
        const n = buy.querySelector('[data-vn-ld-count]');
        n?.removeAttribute('data-vn-ld-count');
        n?.classList.add('vn-fit__sy');
        buy.insertAdjacentHTML('beforeend', '<span class="vn-fit__vi">Vista</span>');
      }
      d.replaceChildren(...[...sh.childNodes].map(own));
    };
    /** @type {Promise<void> | null} */ let first = null;
    const load = () => (first ||= get(urlOf({}, true)).then(fill).catch((err) => { first = null; throw err; }));
    const pressed = () => {
      /** @type {any} */ const o = {};
      P.forEach((p) => { const b = /** @type {HTMLElement | null} */ (d.querySelector(`[data-p="${p}"][aria-pressed="true"]`)); if (b) o[p] = b.dataset.k; });
      return o;
    };
    const key = (/** @type {any} */ p) => `${p.c || ''}|${p.t || ''}`;
    let seq = 0;
    let slow = 0;
    /** @type {any} */ let shown = {}; // the pick whose counts are on the screen (the first fetch: none)
    /** @type {any} */ let ld = null; // the wait in the sheet
    /** @type {string} */ let lastSel = '';
    /** @type {AbortController | null} */ let pend = null; // the count request still out
    // the counts for a pick
    const ask = (/** @type {any} */ pick) => {
      const my = ++seq;
      clearTimeout(slow);
      slow = window.setTimeout(() => d.classList.add('vn-fit__wait'), 300);
      const l = (ld = /** @type {any} */ (window).vnLoader?.(host.id, 'sheet') || null);
      l?.start();
      const end = () => { clearTimeout(slow); d.classList.remove('vn-fit__wait'); };
      const req = get(urlOf(pick, true));
      pend = ctl;
      req.then(({ sh }) => {
        if (my !== seq) return;
        pend = null;
        l?.arrived();
        const f = /** @type {HTMLElement | null} */ (document.activeElement?.closest?.('#vn-skin-sheet [data-p]') || null);
        ['g1', 'g2'].forEach((g) => {
          const a = d.querySelector(`.vn-hud__${g} .vn-hud__wrap`);
          const b = sh.querySelector(`.vn-hud__${g} .vn-hud__wrap`);
          if (a && b) a.replaceChildren(...[...b.childNodes].map(own));
          // 3b: a group with no chip to show (only "Allar húðgerðir") comes without its heading, as the server drew it
          const ga = /** @type {HTMLElement | null} */ (a?.closest('.vn-hud__g') || null);
          const gb = /** @type {HTMLElement | null} */ (b?.closest('.vn-hud__g') || null);
          if (ga && gb) ga.hidden = gb.hidden;
        });
        const n = sh.querySelector('.vn-hud__buy [data-vn-ld-count]');
        const m = d.querySelector('.vn-fit__sy');
        if (n && m) m.textContent = n.textContent;
        shown = pick;
        paint(pick, d);
        end();
        l?.done();
        // focus stays on the pressed choice (or the first of its group, when it left with no products behind it)
        if (f && !f.isConnected) /** @type {HTMLElement | null} */ (d.querySelector(`[data-p="${f.dataset.p}"][data-k="${f.dataset.k}"]`) || d.querySelector(`[data-p="${f.dataset.p}"]`))?.focus({ preventScroll: true });
      }, () => {
        if (my !== seq) return;
        pend = null;
        end();
        if (!isOpen()) { l?.cancel(); return; }
        // the give-up: the pick whose counts are on the screen comes back; "Reyna aftur" asks again for this one
        const sel = lastSel;
        keep(shown);
        paint(shown, d);
        fitPaint();
        l?.fail(() => {
          choose(pick);
          if (sel) /** @type {HTMLElement | null} */ (d.querySelector(sel))?.focus({ preventScroll: true });
        });
      });
    };
    const choose = (/** @type {any} */ pick) => {
      paint(pick, d);
      keep(pick);
      fitPaint();
      ask(pick);
    };
    d.addEventListener('click', (e) => {
      const t = /** @type {HTMLElement | null} */ (/** @type {Element} */ (e.target).closest?.('[data-p][data-v], [data-vn-sk-clear], [data-vn-fit-go]'));
      if (!t || t.getAttribute('aria-disabled') === 'true') return;
      if (t.hasAttribute('data-vn-fit-go')) {
        if (desk.matches) dc.closeDialog();
        else window.location.assign(urlOf(pressed(), false));
        return;
      }
      /** @type {any} */ let pick = {};
      if (t.hasAttribute('data-vn-sk-clear')) lastSel = '[data-vn-sk-clear]';
      else {
        pick = pressed();
        const p = t.dataset.p || '';
        if (pick[p] === t.dataset.k) delete pick[p];
        else pick[p] = t.dataset.k;
        lastSel = `[data-p="${p}"][data-k="${t.dataset.k}"]`;
      }
      choose(pick);
    });
    document.addEventListener('click', (e) => {
      const pill = /** @type {HTMLElement | null} */ (/** @type {Element} */ (e.target).closest?.('.vn-fit__pill'));
      if (!pill || pill.getAttribute('aria-busy') === 'true') return;
      pill.setAttribute('aria-busy', 'true');
      load().then(() => {
        paint(cur(), d);
        const now = pressed();
        dc.showDialog();
        if (key(now) !== key(shown)) ask(now);
      }, () => window.location.assign(coll)).finally(() => pill.removeAttribute('aria-busy'));
    });
    // focus back to the pill, or to the panel's heading once a pick has put the pill away; a give-up showing in the
    // sheet ends with it (its pick was put back)
    d.addEventListener('close', () => {
      if (d.querySelector('[data-vn-ld].is-err')) ld?.cancel();
      const el = fitEl();
      const pill = /** @type {HTMLElement | null} */ (el?.querySelector('.vn-fit__pill') || null);
      const to = pill && pill.offsetParent !== null ? pill : /** @type {HTMLElement | null} */ (el?.querySelector('.vn-fit__h') || null);
      if (to && document.activeElement !== to) to.focus({ preventScroll: true });
    });
    // the choice is fetched when the pill nears the screen, or as it takes focus or a press
    const pre = () => { load().catch(() => { /* tried again on the press */ }); };
    const pill0 = el0.querySelector('.vn-fit__pill');
    if (pill0 && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => {
        if (!es.some((x) => x.isIntersecting)) return;
        io.disconnect();
        (window.requestIdleCallback || ((/** @type {any} */ f) => setTimeout(f, 200)))(pre);
      }, { rootMargin: '300px' });
      io.observe(pill0);
    }
    document.addEventListener('focusin', (e) => { if (/** @type {Element} */ (e.target).closest?.('.vn-fit__pill')) pre(); });
    document.addEventListener('pointerdown', (e) => { if (/** @type {Element} */ (e.target).closest?.('.vn-fit__pill')) pre(); }, true);
    // the opener is marked while the sheet is open, also when a refresh puts the server's aria-expanded="false" back
    const mark = () => {
      const pl = fitEl()?.querySelector('.vn-fit__pill');
      const want = String(isOpen());
      if (pl && pl.getAttribute('aria-expanded') !== want) pl.setAttribute('aria-expanded', want);
    };
    new MutationObserver(mark).observe(d, { attributes: true, attributeFilter: ['open', 'class'] });
    // a product refresh (a shade or size change morphs the section) puts the server's panel back: paint it again
    new MutationObserver(() => { const el = fitEl(); if (el && el.dataset.vnP === undefined) fitPaint(); mark(); }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-vn-p', 'aria-expanded'] });
    // back from the back-forward cache: the pick kept since (on a collection, another product) shows here too
    // (round 2) a count request still out is dropped first: its answer belongs to a pick the page may no longer keep
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      if (pend) {
        seq++;
        pend.abort();
        pend = null;
        clearTimeout(slow);
        d.classList.remove('vn-fit__wait');
        ld?.cancel();
      }
      fitPaint();
      if (!d.firstElementChild) return;
      paint(cur(), d);
      const now = pressed();
      if (isOpen() && key(now) !== key(shown)) ask(now);
    });
  };
  pdp();
})();
